/* jshint -W071 */ // too many statements violation; should factor out standard choice
// form into a directive and reuse with student and classroom create assignment
(function () {
    angular.module('rightPaneModule')
      .controller('GuardianCreateAssignmentController', [
          'dblAnalyticsProvider',
          '$scope',
          '$state',
          '$window',
          'assignedFocusApi',
          'assignMode',
          'authentication',
          'cancelableResourceManager',
          'customer',
          'dblAssignmentService',
          'dblLessonService',
          'moment',
          'standard',
          'studentApi',
          'translateFilter',
          GuardianCreateAssignmentController]);

    function GuardianCreateAssignmentController(
      $analytics,
      $scope,
      $state,
      $window,
      $assignedFocusApi,
      $assignMode,
      dblAuthentication,
      $cancelableResourceManager,
      customer,
      dblAssignmentService,
      dblLessonService,
      moment,
      $standard,
      $studentApi,
      translateFilter
    ) {
        $scope.setInitialState = setInitialState;
        $scope.handlePlayDemoLessonClick = handlePlayDemoLessonClick;

        var DBL_STANDARD_ID = 2;

        var durationSearchName =  translateFilter('assignments.searchForDuration');
        var defaultDurationSpot = { name: translateFilter('assignments.nWeeks', {count: 1}), id: 1 };
        var defaultDurationGoal = { name: translateFilter('assignments.nWeeks', {count: 2}), id: 2 };
        $scope.durationSearchName = durationSearchName;

        var durationGoal = {
            status: {
                opened: false
            },
            weeks: [
                { name: translateFilter('assignments.nWeeks', {count: 2}), id: 2 },
                { name: translateFilter('assignments.nWeeks', {count: 3}), id: 3 },
                { name: translateFilter('assignments.nWeeks', {count: 4}), id: 4 },
                { name: translateFilter('assignments.nWeeks', {count: 5}), id: 5 },
                { name: translateFilter('assignments.nWeeks', {count: 6}), id: 6 },
                { name: translateFilter('assignments.nWeeks', {count: 7}), id: 7 },
                { name: translateFilter('assignments.nWeeks', {count: 8}), id: 8 },
                { name: translateFilter('assignments.nWeeks', {count: 9}), id: 9 },
                { name: translateFilter('assignments.nWeeks', {count: 10}), id: 10 }
            ],
            selected: defaultDurationGoal
        };

        var durationSpot = {
            status: {
                opened: false
            },
            weeks: [
                { name: translateFilter('assignments.nWeeks', {count: 1}), id: 1 },
                { name: translateFilter('assignments.nWeeks', {count: 2}), id: 2 },
            ],
            selected: defaultDurationSpot
        };

        var globalAstName = customer.getAcademicStandard().academic_standard_name;
        var astName = globalAstName;
        $scope.topicStandardChoice = {
            value: astName
        };

        $scope.$watch('topicStandardChoice.value', function (newVal, oldVal) {
            // only do something if value was previously defined
            if (oldVal && newVal !== oldVal) {
                astName = newVal;

                $standard.resetQueryParams({}).then(function () {
                    updateStudentGradesData();
                });
            }
        });

        function setAssignmentDates(durationInWeeks) {
            var assignmentDates = dblAssignmentService.generateAssignmentDates(durationInWeeks);

            $scope.startDate = assignmentDates.start.toDate();
            $scope.endDate = assignmentDates.end.toDate();
        }

        $scope.durationClicked = durationClicked;

        function durationClicked(duration) {
            $scope.duration.selected = duration;

            // duration.id is number of weeks in assignment
            setAssignmentDates(duration.id);
        }

        $scope.$watch('assignmentType', function (value) {
            if ($scope.assignmentType === 'GOAL') {
                $scope.duration = durationGoal;
                $scope.duration.selected = defaultDurationGoal;
                setAssignmentDates(defaultDurationGoal.id);
            } else {
                $scope.duration = durationSpot;
                $scope.duration.selected = defaultDurationSpot;
                setAssignmentDates(defaultDurationSpot.id);
            }
        });

        function setInitialState() {
            $scope.assignStatus = {
                busy: true,
                allowSave: false
            };

            // default to 1 week duration
            setAssignmentDates(1);

            $scope.standardSelected = false;
            $scope.assignmentType = "SPOT";

            $scope.duration = durationSpot;

            $scope.studentId = $state.params.studentId;

            var authCustomer = dblAuthentication.getCustomer();

            // studentDistrictId is equal to -1 for students that aren't in classrooms
            $scope.allowAssignmentInteraction = $state.params.studentDistrictId === '-1' || authCustomer.hasTag('ASSIGN_FOCUS_ENABLED');

            $scope.customerId = authCustomer.id;
        }

        $scope.setInitialState();

        function updateStudentGradesData() {
            $scope.grades = [];
            $scope.standards = [];
            $scope.standardSelected = false;

            $scope.noStudentHasAssignment = true;

            if ($scope.allowAssignmentInteraction) {
                var promise = $studentApi.getStudentGradesForGuardian($state.params.studentId, astName, function (data) {
                    $scope.grades = angular.copy(data.grades);
                    $cancelableResourceManager.remove(pid);
                });
                var pid = $cancelableResourceManager.add(promise);
            }
        }

        function updateStudentDomainsData() {
            $scope.assignStatus.allowSave = false;
            $scope.domains = [];
            $scope.standardSelected = false;

            $scope.noStudentHasAssignment = true;

            var params = $standard.getParams();
            if (_.isUndefined(params.grade)) {
                return;
            }

            var promise = $studentApi.getStudentDomainsForGuardian($state.params.studentId, params.grade, function (data) {

                _.remove(data.domains, function (domain) {
                    return domain.code === "0";
                });

                $scope.domains = angular.copy(data.domains);
                $cancelableResourceManager.remove(pid);
            });
            var pid = $cancelableResourceManager.add(promise);
        }

        function updateStudentStandardsData() {

            $scope.noStudentHasAssignment = true;
            $scope.standardSelected = false;

            var params = $standard.getParams();

            // If there is no grade or domain - clear the standards list.
            $scope.standards = [];
            if (_.isUndefined(params.grade) || _.isUndefined(params.domain)) {
                return;
            }

            $studentApi.getStudentStandardsForGuardian($state.params.studentId, params.grade, params.domain).then(function (data) {
                $scope.standards = data;
                $scope.assignStatus.busy = false;

                getAssignment();
            });
        }

        function getAssignment() {
            $scope.busy = true;
            var promise = $assignedFocusApi.getStudentActiveLessons([$state.params.studentId], function (data) {
                $scope.active_engagement = data[0].active_engagement;

                // Get primary/intermediate status
                var assignments = angular.copy(data);

                $scope.assignment = assignments.pop();
                $scope.assignment2 = assignments.pop();

                $scope.tooManyAssignments = $scope.assignment2 !== null;

                if ($scope.assignment) {
                    getDescription.call($scope.assignment);
                }

                if ($scope.assignment2) {
                    getDescription.call($scope.assignment2);
                }

                var focus_id = parseInt($scope.currentStandard.code);
                var focus_type = $scope.currentStandard.hasOwnProperty('cluster') ? 'CLUSTER' : 'STANDARD';

                setIsSameFocusArea();
                watchCurrentStandard();

                $scope.busy = false;
                $cancelableResourceManager.remove(pid);
            });
            var pid = $cancelableResourceManager.add(promise);
        }

        function processProficiencySlots() {

            if (_.isUndefined($standard.getParams().standard)) {
                return;
            }

            var focus_type = $scope.currentStandard.hasOwnProperty('cluster') ? 'cluster' : 'standard';

            var slotPromise = $assignedFocusApi.getProficiencySlots(focus_type, $standard.getParams().standard).then(function (resource) {
                $scope.notStartedLessonSlotId = resource.data.not_started_lesson_slot_id;
                $scope.inProgressLessonSlotId = resource.data.in_progress_lesson_slot_id;
                $scope.proficientLessonSlotId = resource.data.proficient_lesson_slot_id;
            });
        }

        function setIsPrimaryStandardSelected() {

        }

        function getDescription() {
            this.description = '';
            this.end_date = moment(this.end_date);
            this.description = this.name;
        }

        function watchCurrentStandard() {
            $scope.$watch('currentStandard', function () {
                if ($scope.sameFocusArea || $scope.assignment2 || ($scope.currentStandard && !$scope.currentStandard.code)) {
                    $scope.assignStatus.allowSave = false;
                } else {
                    $scope.assignStatus.allowSave = true;
                }
            });
        }

        function assignLesson() {
            $scope.assignStatus.busy = true;
            var list = [];
            list[0] = $state.params.studentId;
            $assignedFocusApi.createAssignment(list, $scope.assignmentType, $scope.duration.selected.id, onLessonAssignmentComplete, onLessonAssignmentError);
        }

        function onLessonAssignmentComplete() {
            $analytics.eventTrack('Student Standards Assign Lesson', {
                category: 'Assign Focus',
                label: $scope.item.type + '-' + $scope.item.id + ', standard-' + $standard.getParams().standard
            });

            $scope.$broadcast('assignLessonSuccess');
            $assignMode.onCreateAssignmentSuccess();
        }

        function onLessonAssignmentError(rejection) {
            $scope.assignStatus.busy = false;
            $assignMode.onCreateAssignmentRejected(rejection);
        }

        function onClickCreateAssignment() {
            $scope.assignStatus.allowSave = false;

            assignLesson();
        }

        $scope.$watch('grades', function (newValue, oldValue) {
            // no data
            if (!newValue || !newValue.length) {
                return;
            }
            // data is hasn't changed
            if (angular.equals(newValue, oldValue)) {
                return;
            }
            $scope.$broadcast('gradesLoaded', newValue, astName);
        }, true);

        $scope.$watch('domains', function (newValue, oldValue) {
            // no data
            if (!newValue) {
                return;
            }
            // data is hasn't changed
            if (angular.equals(newValue, oldValue)) {
                return;
            }
            $scope.$broadcast('domainsLoaded', {
                astName: astName,
                domains: newValue
            });
        }, true);

        $scope.$watch('standards.clusters', function (newValue, oldValue) {
            // data is hasn't changed
            if (angular.equals(newValue, oldValue)) {
                return;
            }
            $scope.$broadcast('standardsLoaded', {
                astName: astName,
                standards: $scope.standards
            });
        }, true);

        $scope.$watch('assignStatus', function () {
            $scope.$emit('assignStatusChange', $scope.assignStatus);
        });

        function updateSelectedStandard(e, standard) {
            $scope.currentStandard = standard;
            $scope.notStartedLessonSlotId = null;

            if (standard.code) {
                $scope.standardSelected = true;
            }

            var student_name = $scope.item.user_names[$state.params.studentId];
            var percent_complete = standard.percent_complete.toFixed(1);

            if (percent_complete === '0.0') {
                $scope.lessonTypeDescription = translateFilter('assignments.lessonNotStarted', {name: student_name});
                $scope.lessonTypeClass = "circle-not-started";
            } else if (percent_complete === '100.0') {
                $scope.lessonTypeDescription = translateFilter('assignments.lessonProficient', {name: student_name});
                $scope.lessonTypeClass = "circle-proficient";
            } else {
                $scope.lessonTypeDescription = translateFilter('assignments.lessonInProgress', {name: student_name, percent: percent_complete});
                $scope.lessonTypeClass = "circle-in-progress";
            }

            if (e.name === 'standardClicked') {
                // $scope.$emit("standardSelectedText", $scope.standards.selected.name, $scope.standards.selected.description);
                $scope.standardName = standard.name;
                $scope.standardDescription = standard.description;
            }
            else {
                $scope.standardName = standard.name;
                $scope.standardDescription = null;
            }

            setIsSameFocusArea();
            processProficiencySlots();
        }

        function setIsSameFocusArea() {
            if ($scope.assignment) {
                var focus_id = parseInt($scope.currentStandard.code);
                var focus_type = $scope.currentStandard.hasOwnProperty('cluster') ? 'CLUSTER' : 'STANDARD';

                $scope.sameFocusArea = parseInt($scope.assignment.focus_id) === focus_id && $scope.assignment.focus_type === focus_type;
            }
        }

        function handlePlayDemoLessonClick($event, lesson_slot_id) {
            $event.stopPropagation();
            dblLessonService.openPlayLessonLink(lesson_slot_id);
        }

        function startFetchingStandardsData() {
            $scope.grades = [];
            $scope.domains = [];
            $scope.standards = [];
            $scope.standardSelected = false;

            updateStudentGradesData();
        }

        function initializeData(e, item) {
            $scope.item = item;

            startFetchingStandardsData();
        }

        function updateStudentDataForGuardian(e) {
            if ($scope.studentId !== $state.params.studentId) {
                $state.reload();
            }
        }

        $scope.$on('itemReady', initializeData);
        $scope.$on('loadDomains', updateStudentDomainsData);
        $scope.$on('loadStandards', updateStudentStandardsData);
        $scope.$on('clusterClicked', updateSelectedStandard);
        $scope.$on('standardClicked', updateSelectedStandard);
        $scope.$on('createAssignmentTriggered', onClickCreateAssignment);

        $scope.$on('updateStudentDataForGuardian', updateStudentDataForGuardian);
    }
})();
/* jshint +W071 */
